// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"styles_tableWrap__S3x9o"};